import { ButtonLargeSpecialTheme } from "../../Blocks/ButtonLargeSpecialBlock/ButtonLargeSpecialBlock";
import "./ErrorPage.scss";
import {
  ButtonLargeSpecialBlock,
  GridPresetErrorPage,
  GridRow,
  HouseLineIcon,
} from "/App.Components";
import { ErrorPageProps } from "/Models/Generated/ErrorPageProps";
import classNames from "classnames";

const ErrorPage = ({
  heading,
  text,
  link,
  secondaryBackgroundTheme,
}: ErrorPageProps) => (
  <div
    className={classNames("error-page-norad", {
      "error-page-norad--theme-secondary": secondaryBackgroundTheme,
    })}
  >
    <GridRow>
      <GridPresetErrorPage>
        <div className="error-page-norad__container">
          {heading && <h1 className="error-page-norad__heading">{heading}</h1>}
          {text && <p className="error-page-norad__text">{text}</p>}
          {link && (
            <ButtonLargeSpecialBlock
              link={link}
              theme={ButtonLargeSpecialTheme.Pop}
              notFullWidth
              icon={
                <HouseLineIcon
                  size="32"
                  thickness="Light"
                  color="transparent"
                />
              }
            />
          )}
        </div>
      </GridPresetErrorPage>
    </GridRow>
  </div>
);

export default ErrorPage;
